import { Link } from "react-router-dom";
import { ASSETS } from "@/lib/assets";
import { SEO } from "@/components/SEO";

export const NotFound = () => {
  return (
    <section className="min-h-screen flex items-center">
      <SEO
        title="Siden findes ikke – 404"
        description="Den ønskede side blev ikke fundet. Vend tilbage til forsiden eller ring til Farum Kloak på 44 48 06 16."
        noindex
      />
      <div className="max-w-3xl mx-auto px-6 md:px-12 text-center py-32">
        <div className="eyebrow mb-6">Fejl 404</div>
        <h1 className="font-display text-6xl md:text-8xl leading-tight mb-8">
          Siden findes <em className="text-[color:var(--fk-gold)]">ikke.</em>
        </h1>
        <p className="text-white/60 font-light mb-12">
          Linket er måske flyttet, eller du har skrevet adressen forkert.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="px-7 py-4 text-[11px] tracking-[0.24em] uppercase bg-[color:var(--fk-gold)] text-black hover:bg-[color:var(--fk-gold-hi)] transition-colors"
          >
            Til forsiden
          </Link>
          <a
            href={ASSETS.brand.phoneTel}
            className="px-7 py-4 text-[11px] tracking-[0.24em] uppercase border border-white/20 hover:border-[color:var(--fk-gold)] hover:text-[color:var(--fk-gold)] transition-colors"
          >
            Ring {ASSETS.brand.phone}
          </a>
        </div>
      </div>
    </section>
  );
};
